/**
 * Holds all possible values of the SPARQL queries.
 * @type {{ADD: string, CONSTRUCT: string, CREATE: string, LOAD: string, COPY: string, SELECT: string, DROP: string, DELETE: string, MOVE: string, ASK: string, INSERT: string, DESCRIBE: string, CLEAR: string}}
 */
export const QueryType = {
    "SELECT": "SELECT",
    "CONSTRUCT": "CONSTRUCT",
    "ASK": "ASK",
    "DESCRIBE": "DESCRIBE",
    "INSERT": "INSERT",
    "DELETE": "DELETE",
    "LOAD": "LOAD",
    "CLEAR": "CLEAR",
    "CREATE": "CREATE",
    "DROP": "DROP",
    "COPY": "COPY",
    "MOVE": "MOVE",
    "ADD": "ADD"
};
